module.exports = __webpack_public_path__ + "img/p2-63.2f319195.png";